import { render, staticRenderFns } from "./PhaseTerms.vue?vue&type=template&id=98ab655c&"
import script from "./PhaseTerms.vue?vue&type=script&lang=js&"
export * from "./PhaseTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports